import { Text } from '@oneaudi/unified-web-components';
import { Footnote } from '~/components/footnotes/footnote-context';
import { FootnoteRendererStyle } from '~/components/footnotes/footnote-renderer-style';
import { useFootnotes } from '~/components/footnotes/use-footnote';
import { RenderHtml } from '~/components/text';

export const FootnoteRenderer = () => {
	const { getFootnotes } = useFootnotes();

	const footnotes = getFootnotes();

	if (footnotes.length === 0) {
		return <></>;
	}

	return (
		<FootnoteRendererStyle>
			{footnotes.map((footnote, index) => (
				<FootnoteComponent
					key={footnote.key}
					footnote={footnote}
					reference={String.fromCharCode(index + 'a'.charCodeAt(0))}
				/>
			))}
		</FootnoteRendererStyle>
	);
};

function FootnoteComponent({ reference, footnote }: { reference: string | number; footnote: Footnote }) {
	return (
		/* eslint-disable-next-line */
		<li tabIndex={0}>
			<span data-footnote-reference={reference} id={reference.toString()}>
				<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>{reference}</Text>
			</span>
			<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>
				<RenderHtml html={footnote.value} />
			</Text>
		</li>
	);
}

export function scrollToFootnote(reference: string | number) {
	const elements = document?.querySelectorAll(`[data-footnote-reference="${reference}"]`);
	elements?.forEach((element) => {
		element.scrollIntoView({ behavior: 'smooth' });
		const footnoteParagraph = element.nextElementSibling;
		if (footnoteParagraph && footnoteParagraph instanceof HTMLElement) {
			footnoteParagraph.tabIndex = -1;
			footnoteParagraph.focus();
		}
	});
}
